var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNutritionGrayIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.03 25.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-nutrition-gray{fill:#5c5e71;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6114",
    "data-name": "Group 6114"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6113",
    "data-name": "Group 6113"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_22507",
    "data-name": "Path 22507"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-nutrition-gray",
    d: "M16.25,23.23A1.24,1.24,0,0,1,15,22v0c0-.39.2-5.4.47-8.08a.6.6,0,0,0-.29-.6,1.91,1.91,0,0,1-.88-1.62c0-.59.58-4.3,1.94-4.3s1.95,3.78,1.95,4.3a1.91,1.91,0,0,1-.9,1.61.43.43,0,0,1-.6,0,.4.4,0,0,1,0-.56h0a.48.48,0,0,1,.2-.14,1.11,1.11,0,0,0,.47-.9c0-1-.71-3.33-1.13-3.47-.39.13-1.1,2.48-1.1,3.47a1.07,1.07,0,0,0,.49.92A1.39,1.39,0,0,1,16.3,14c-.27,2.74-.46,7.72-.46,8a.41.41,0,0,0,.41.41h0a.39.39,0,0,0,.38-.41h0c0-.25-.12-3.47-.31-6.19a.4.4,0,0,1,.4-.42.41.41,0,0,1,.42.36c.19,2.64.32,5.93.32,6.25a1.22,1.22,0,0,1-1.21,1.23"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_22508",
    "data-name": "Path 22508"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-nutrition-gray",
    d: "M20.77,23.23A1.23,1.23,0,0,1,19.53,22v0c0-.38.18-4.86.44-7.57a.65.65,0,0,0-.36-.63,1.26,1.26,0,0,1-.78-1.08c0-.32.15-2.65.41-5a.42.42,0,0,1,.46-.36.4.4,0,0,1,.36.45c-.27,2.38-.41,4.65-.41,4.86s.09.22.33.34a1.46,1.46,0,0,1,.81,1.43c-.27,2.8-.43,7.25-.43,7.51a.4.4,0,0,0,.4.41h0a.41.41,0,0,0,.41-.41c0-.24-.14-3.49-.34-6.19a.42.42,0,0,1,.83-.06c.19,2.67.34,5.94.34,6.25a1.26,1.26,0,0,1-1.24,1.24m1-9.33-.47-.68a1.69,1.69,0,0,1,.29-.17c.23-.12.33-.27.33-.34,0-.23-.17-2.51-.42-4.86a.42.42,0,0,1,.83-.09c.25,2.4.41,4.67.41,5a1.26,1.26,0,0,1-.79,1.07l-.18.11"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_22509",
    "data-name": "Path 22509"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-nutrition-gray",
    d: "M20.77,12.81a.41.41,0,0,1-.41-.41h0V7.78a.41.41,0,0,1,.82,0V12.4a.41.41,0,0,1-.41.41h0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_22510",
    "data-name": "Path 22510"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-nutrition-gray",
    d: "M14,21.94H2.8a1.48,1.48,0,0,1-1.48-1.48V4.77A1.48,1.48,0,0,1,2.8,3.29H4.64a.41.41,0,0,1,.42.41.42.42,0,0,1-.42.42H2.8a.66.66,0,0,0-.66.65V20.46a.66.66,0,0,0,.64.66H14a.41.41,0,0,1,0,.82M15.43,7A.42.42,0,0,1,15,6.54h0V4.77a.65.65,0,0,0-.65-.65H13.09a.42.42,0,0,1-.41-.42.41.41,0,0,1,.41-.41h1.27a1.48,1.48,0,0,1,1.48,1.48V6.54a.42.42,0,0,1-.41.42h0M12,4.12H9.43A.42.42,0,0,1,9,3.7a.41.41,0,0,1,.42-.41H12a.41.41,0,0,1,.41.41.41.41,0,0,1-.41.42m-3.67,0H5.74a.42.42,0,0,1-.42-.42.41.41,0,0,1,.42-.41H8.31a.41.41,0,0,1,.41.41.41.41,0,0,1-.41.42"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_22511",
    "data-name": "Path 22511"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-nutrition-gray",
    d: "M4.91,5.57a.41.41,0,0,1,0-.82c.14,0,.41-.37.41-1s-.27-1-.41-1-.44.4-.44,1a.41.41,0,0,1-.82,0h0c0-1.05.55-1.87,1.26-1.87s1.24.8,1.24,1.87S5.62,5.57,4.91,5.57"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_22512",
    "data-name": "Path 22512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-nutrition-gray",
    d: "M8.58,5.57a.41.41,0,1,1,0-.82c.15,0,.43-.4.43-1s-.28-1-.43-1-.42.41-.42,1a.41.41,0,1,1-.82,0c0-1.07.54-1.87,1.24-1.87s1.26.82,1.26,1.87S9.3,5.57,8.58,5.57"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_22513",
    "data-name": "Path 22513"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-nutrition-gray",
    d: "M12.25,5.57a.41.41,0,1,1,0-.82c.15,0,.43-.4.43-1s-.28-1-.43-1-.42.4-.42,1a.41.41,0,1,1-.82,0c0-1.06.53-1.87,1.24-1.87s1.26.82,1.26,1.87S13,5.57,12.25,5.57"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_22514",
    "data-name": "Path 22514"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-nutrition-gray",
    d: "M13.12,8.75h-.58a.41.41,0,1,1,0-.82h.58a.41.41,0,1,1,0,.82"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_22515",
    "data-name": "Path 22515"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-nutrition-gray",
    d: "M10.52,8.75H4a.41.41,0,1,1,0-.82h6.48a.41.41,0,0,1,0,.82"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_22516",
    "data-name": "Path 22516"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-nutrition-gray",
    d: "M13.12,10.75h-.58a.42.42,0,0,1-.42-.42.41.41,0,0,1,.42-.41h.58a.41.41,0,0,1,.41.41.41.41,0,0,1-.41.42"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_22517",
    "data-name": "Path 22517"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-nutrition-gray",
    d: "M10.52,10.75H4a.42.42,0,0,1-.42-.42A.41.41,0,0,1,4,9.92h6.48a.41.41,0,0,1,.41.41.41.41,0,0,1-.41.42"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_22518",
    "data-name": "Path 22518"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-nutrition-gray",
    d: "M13.12,12.76h-.58a.41.41,0,0,1-.41-.41.42.42,0,0,1,.41-.42h.58a.42.42,0,0,1,.41.42.41.41,0,0,1-.41.41"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_22519",
    "data-name": "Path 22519"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-nutrition-gray",
    d: "M10.52,12.76H4a.41.41,0,0,1-.41-.41A.42.42,0,0,1,4,11.93h6.48a.42.42,0,0,1,.41.42.41.41,0,0,1-.41.41"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_22520",
    "data-name": "Path 22520"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-nutrition-gray",
    d: "M13.12,14.75h-.58a.41.41,0,1,1,0-.82h.58a.41.41,0,1,1,0,.82"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_22521",
    "data-name": "Path 22521"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-nutrition-gray",
    d: "M10.52,14.75H4a.41.41,0,1,1,0-.82h6.48a.41.41,0,0,1,0,.82"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_22522",
    "data-name": "Path 22522"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-nutrition-gray",
    d: "M13.12,16.74h-.58a.41.41,0,1,1,0-.82h.58a.41.41,0,1,1,0,.82"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_22523",
    "data-name": "Path 22523"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-nutrition-gray",
    d: "M10.52,16.74H4a.41.41,0,1,1,0-.82h6.48a.41.41,0,1,1,0,.82"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_22524",
    "data-name": "Path 22524"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-nutrition-gray",
    d: "M13.12,18.73h-.58a.41.41,0,1,1,0-.82h.58a.41.41,0,1,1,0,.82"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_22525",
    "data-name": "Path 22525"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-nutrition-gray",
    d: "M10.52,18.73H4a.41.41,0,1,1,0-.82h6.48a.41.41,0,1,1,0,.82"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNutritionGrayIcon);
export default __webpack_public_path__ + "static/media/Nutrition_Gray_Icon.42465af3.svg";
export { ForwardRef as ReactComponent };